<template>
  <div class="bottom">
    <div class="footer clearfix pc" v-if="isDesktop" id="footer">
      <div class="w">
        <div class="fl">
          <p class="subnavs">
            <a href="/" title="网站首页">网站首页</a>
            <a href="/about">关于我们</a>
            <a href="/team">师资力量</a>
            <a href="/zhishi">培训知识</a>
            <a href="/course">全部课程</a>
            <a href="/xueyuan">客户案例</a>
            <a href="/news">新闻资讯</a>
            <a href="/contact">联系我们</a>
            <a href="/user/PersonalCenter">个人中心</a>
          </p>
          <div class="copyright clearfix">
            <p>
              {{ nowBottom.copyright }}
              <br />
              咨询报名热线：{{ nowBottom.company_mobile }}
              <br />
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="nofollow"
                >{{ nowBottom.beian }}</a
              >
              <!-- <a href="javascript:" target="_blank">XML地图</a> -->
              <!-- <a href="javascript:" target="_blank">网站模板</a> -->
            </p>
          </div>
        </div>
        <div class="fr">
          <!-- <div class="go_top s" id="goTop1"></div> -->
          <div class="subtel">
            <span class="s">咨询热线</span>
            <p ig-phone>{{ nowBottom.tel }}</p>
          </div>
          <div class="searcher" id="searcher">
            <form action="javascript:;" method="get" >
              <input  id="submit" class="submit s" @click="handleSearch"/>
              <input
                type="text"
                class="txt s"
                placeholder="请输入关键词"
                v-model="searchQuery"
                name="keyword"
                id="keywords"
              />
            </form>
          </div>
        </div>

        <dl class="toolbar" id="toolbar" v-if="isDesktop">
          <!--<dd> <a class="slide qq slide-qq" href="tencent://message/?uin=&amp;Menu=yes">在线QQ</a> </dd>-->
          <dd>
            <i class="code"></i>
            <ul class="pop pop-code">
              <li class="o"></li>
              <li>
                <img :src="http + nowBottom.gzh" />
                <h3>微信公众号</h3>
              </li>
            </ul>
          </dd>
          <dd>
            <i class="tell"></i>
            <ul class="pop pop-tel">
              <li class="o"></li>
              <li class="icon">咨询热线</li>
              <li class="item" ig-phone>{{ nowBottom.tel }}</li>
            </ul>
          </dd>
          <dd>
            <i class="code"></i>
            <ul class="pop pop-code">
              <li class="o"></li>
              <li>
                <img :src="http + nowBottom.wxcode" />
                <h3>微信二维码</h3>
              </li>
            </ul>
          </dd>
          <dd>
            <i id="goTop" class="top" @click="scrollToTop"></i>
          </dd>
        </dl>

        <div class="clear"></div>
      </div>
    </div>
    <div class="move" v-else>
      <div class="toolbar">
        <dl class="list clearfix">
          <dd>
            <a href="/" class="too-home">首页</a>
          </dd>
          <dd>
            <a href="/contact" class="too-map">联系</a>
          </dd>
          <dd>
            <a href="tel:18660779222" class="too-tel">电话</a>
          </dd>
          <dd>
            <a href="sms:18660779222" class="too-qiao">咨询</a>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import method from "@/utils/Untitl.js";
export default {
  props: {
    nowBottom: {
      // type: Array,
      required: true,
    },
  },
  data() {
    return {
      isDesktop: window.innerWidth > 428,
      http: process.env.VUE_APP_BASE_API,
      searchQuery: "",
    };
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener("resize", this.handleResize);
    // this.getBottom();
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 根据窗口宽度更新 isDesktop 状态
    },
    // 添加滚动到顶部的方法
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    },
    // 搜索
    handleSearch() {
      this.$router
        .push({
          path: "/course/course_in",
          query: { name: this.searchQuery },
        })
        .catch((err) => {
          // 只忽略“重复导航”错误，其他错误继续抛出
          if (err.name !== "NavigationDuplicated") throw err;
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/pc/bottom.scss";
@import "@/assets/css/move/bottom.scss";
</style>
